import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { memberMobx, giftCardMobx, memberCardMobx, activityMobx, decorationMobx, pointCardMobx, invoiceMobx } from '@mobxStore'
import { modalLayer, toast, getPlatform, useHistoryNew, localStore } from '@utils'
import { getParams } from '@dt/fe-utils'
import { MktController } from '@ctrls/index'
import { useGiftCardDecorationInit, useGiftCardPageTitle } from '@common/hooks'
import { PowerByEShine, LotteryModule, UnacquiredCoupon, PointCardModule, MyCardModule, GiftCardModule, ResultAlert, CouponItem } from '@cps'
import HeaderBack from '../components/HeaderBack'
import HeaderModule from '../components/HeaderModule'
import EntryModule from '../components/EntryModule'
import ActiveModule from '../components/ActiveModule'
import SecondTempModule from '../components/SecondTempModule'
import ThreeTempModule from '../components/ThreeTempModule'
import { MemberBusy } from '@pages/mkt/components'
import './index.scss'
import { permissionMobx } from '@mobx/app'

const { isAliPayMiniProgram } = getPlatform()
interface IProps extends IPage, RouteComponentProps {
  match: any;
  location: any;
}

const My: FC<IProps> = ({ location }: IProps) => {
  const [canReceive, setCanReceive] = useState(false)
  const history = useHistoryNew()
  const routeInfo: any = history.getRouteInfo()
  let myCardId = ''
  if (!routeInfo?.routeDirection || routeInfo?.routeDirection !== 'back') {
    if (location?.state?.cardId) {
      myCardId = `${location.state.cardId}`
    } else if (getParams()?.cardId) {
      myCardId = getParams()?.cardId
    }
  }
  const { unacquiredCoupons, refreshMemeberBenefits, getActivityState, getUnacquiredCoupons } = memberMobx
  const {
    mktDecorates
  } = decorationMobx
  const { getCardList } = memberCardMobx
  const { eGiftCardList, getEGiftCardList } = giftCardMobx
  const { getEntryActive, lotteryList, } = activityMobx
  const { pointCardList, getPointCardList } = pointCardMobx

  useIonViewWillEnter(() => {
    getEGiftCardList()
    getEntryActive()
    if (!permissionMobx.checkAuthToKey('electronic_invoice')) {
      invoiceMobx.init()
    }
    getActivityState()
    if (memberMobx.token) {
      getCardList()
      getPointCardList()
    }
    if (memberMobx.isLogin) {
      refreshMemeberBenefits()
      toGetUnacquiredCoupons()
      toGetUnacquiredConsumeCoupons()
    } else {
      memberMobx.initData().then(() => {
        toGetUnacquiredCoupons()
      })
      memberCardMobx.initData()
      activityMobx.initData()
      pointCardMobx.initData()
    }
  })

  useGiftCardDecorationInit()
  useGiftCardPageTitle()

  /**
   * 领取优惠券
   */
  const toGetUnacquiredCoupons = () => {
    if (!memberMobx.brandConfig.isAutoAcquireCoupon) {
      getUnacquiredCoupons().then((res: any) => {
        if (res.length > 0) {
          couponChange(res[0].coupons)
        }
      })
    }
  }
  /**
   * 领取消费送优惠券
   */
  const toGetUnacquiredConsumeCoupons = () => {
    if (history.getPrevState() !== '/login') {
      const consumeCouponsInfo = localStore.get(memberMobx.consumeCouponsKey)
      if (consumeCouponsInfo) {
        MktController.sendCoupons({
          ordersId: consumeCouponsInfo.ordersId,
          activityId: consumeCouponsInfo.activityId || ''
        })
      }
    }
  }

  const couponChange = (coupons: any) => {
    modalLayer(ResultAlert, {
      title: i18n.t('mkt.coupon.couponGet'),
      btnTitle: i18n.t('mkt.member.claimAll'),
      children: coupons.map((item: any, index: number) => {
        return (
          <div className='coupon-block' key={item.couponId}>
            <CouponItem type='get' couponInfo={item} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
          </div>)
      })
    }).then(() => {
      MktController.checkLogin(history).then(() => {
        memberMobx.acquiredCouponList().then((res: any) => {
          if (res) {
            toast({ message: i18n.t('mkt.coupon.receivedSucc') })
          }
        })
      })
    }).catch(() => { })
  }
  return (
    <IonPage className='my-page'>
      {!window.MEMBERISBUSY ? (
        <IonContent className='page-content'>
          {mktDecorates?.memberTemp === 'newplan' ? null : <HeaderBack></HeaderBack>}
          <div className='page-body'>
            <div className='my-page-con'>
              {
                mktDecorates?.memberTemp === 'newplan' ? (
                  <>{memberMobx.isLogin && memberCardMobx.allCardList.length > 0 && <SecondTempModule cardId={myCardId || ''} />}</>
                ) : (
                  mktDecorates?.memberTemp === 'threeTemp' ? (
                    <><ThreeTempModule cardId={myCardId || ''} /></>
                  ) : (
                    <>
                      <HeaderModule></HeaderModule>
                      {
                        memberMobx.isLogin && memberCardMobx.allCardList.length > 0 && (
                          <div className='module-area no-lr-padd'>
                            <MyCardModule source='my' cardId={myCardId || ''}></MyCardModule>
                          </div>
                        )
                      }
                    </>
                  )
                )
              }
              <div className='module-area'>
                <EntryModule></EntryModule>
              </div>
              {
                mktDecorates.market.map((item: any, index: number) => {
                  if (item.type === 'fixed') {
                    if (!isAliPayMiniProgram && item.key === 'giftCard' && eGiftCardList.length > 0) {
                      return (
                        <div className='module-area' key={index}>
                          <GiftCardModule />
                        </div>
                      )
                    } else if (item.key === 'luckyDraw' && lotteryList.length > 0) {
                      return (
                        <div className='module-area' key={index}>
                          <LotteryModule />
                        </div>
                      )
                    } else if (item.key === 'receiveCoupon' && unacquiredCoupons.length > 0) {
                      return (
                        <div className='module-area' key={index}>
                          <UnacquiredCoupon />
                        </div>
                      )
                    } else if (item.key === 'setPoint' && pointCardList.length > 0) {
                      return (
                        <div className='module-area no-lr-padd' key={index}>
                          <PointCardModule />
                        </div>
                      )
                    } else {
                      return ''
                    }
                  } else {
                    return (
                      <div className='module-area' key={index}>
                        <ActiveModule info={item}></ActiveModule>
                      </div>
                    )
                  }
                })
              }
              {/* <VersionBar /> */}
              <PowerByEShine />
            </div>
          </div>
        </IonContent>
      ) : (
        <MemberBusy />
      )}
    </IonPage>
  )
}

export default observer(My)
